// const baseUrl = process.env.NODE_ENV === 'production' ? 'http://sn.oricos.cn/api' : '/api'
const baseUrl = process.env.NODE_ENV === 'production' ? '/api' : '/api'
console.log('process.env.NODE_ENV:',process.env.NODE_ENV)
module.exports = baseUrl;
// export default baseUrl